<template>
  <div class="e-study">
    <video-player
      :current="current"
      :chapters="chapters"
      :currentChapterIndex="currentChapterIndex"
      :currentSegmentIndex="currentSegmentIndex"
      @updateProgress="updateProgress"
      @next="nextSegment"
    />
    <ul class="e-study-tabs">
      <li :class="currentTab === 'chapter' ? 'act' : ''" @click="currentTab = 'chapter'">章节</li>
      <li :class="currentTab === 'download' ? 'act' : ''" @click="currentTab = 'download'">资料</li>
    </ul>
    <div v-if="currentTab === 'chapter'" class="e-study-left-nav-item-content">
      <ul class="e-study-left-nav-item-chapters" v-if="chapters.length">
        <li class="e-study-left-nav-item-chapter" v-for="(chapter, chapterIndex) in chapters" :key="`chapter-${chapterIndex}`">
          <p class="e-study-left-nav-item-chapter-title">{{chapter.title}}</p>
          <ul class="e-study-left-nav-item-segments">
            <li @click="changeCurrent(segment, segmentIndex, chapter, chapterIndex)" class="e-study-left-nav-item-segment" v-for="(segment, segmentIndex) in chapter.listdata" :key="`segment-${segmentIndex}`">
              <i class="iconfont icon-sj-2 e-study-left-nav-item-segment-play"></i>
              {{chapterIndex | indexToNumbering}}-{{segmentIndex | indexToNumbering}} {{segment.title}}
              <span class="e-study-left-nav-item-segment-state" :class="[segment.lostatus === 1 ? 'e-study-left-nav-item-segment-state-done' : '', segment.isCurrent ? 'e-study-left-nav-item-segment-state-doing' : '']"></span>
            </li>
            <li v-if="chapter.onstatus" class="e-study-left-nav-item-segment">
              <router-link :to="isOpen ? `/m/topic/${$route.params.id}/${chapterIndex}/${chapter.exstatus}` : ''">
                <i class="iconfont icon-zhuxingtu e-study-left-nav-item-segment-play"></i>
                阶段测试
                <span class="e-study-left-nav-item-segment-state" :class="[chapter.exstatus === 1 ? 'e-study-left-nav-item-segment-state-done' : '', chapterIndex == current.chapterIndex ? 'e-study-left-nav-item-segment-state-doing' : '']"></span>
              </router-link>
            </li>
          </ul>
        </li>
      </ul>
    </div>
    <div v-if="currentTab === 'download'" class="e-study-download">
      <li class="e-program-file-item text-overflow" v-for="(file, fileIndex) in downloads" :key="fileIndex">
        <span>{{file.fileext | getFileType}}</span>
        {{file.title}}
        <a target="_blank" :href="file.fileurl">下载</a>
      </li>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import VideoPlayer from './components/VideoPlayer'
import api from '@/api/index'
import { message } from 'element-ui'
Vue.prototype.$message = message;

export default {
  components: {
    VideoPlayer,
  },
  data () {
    return {
      state: 'video',
      chapters: [],
      current: null,
      currentChapterIndex: null,
      currentSegmentIndex: null,
      lessonInfo: null,
      downloads: null,
      currentTab: 'chapter'
    }
  },
  computed: {
    isOpen () {
      return new Date().getTime() > new Date(this.info.classstar * 1000).getTime()
    },
  },
  filters: {
    indexToNumbering (val) {
      return val * 1 + 1
    },
    getFileType (val) {
      if (val.match(/\/\w+\.gif/)) {
        return val.match(/\/\w+\.gif/)[0].replace('.gif', '').replace('/', '').toUpperCase()
      } else {
        return '文件'
      }
    }
  },
  methods: {
    updateProgress () {
      this.$set(this.current, 'lostatus', 1)
    },
    changeCurrent (segment, segmentIndex, chapter, chapterIndex) {
      if (this.current) {
        this.current.isCurrent = false
      }
      segment.isCurrent = true
      if (segment.videourl) {
        this.state = 'video'
      } else {
        this.state = 'topic'
      }
      this.currentChapterIndex = chapterIndex
      this.currentSegmentIndex = segmentIndex
      this.current = segment
      this.$set(this.chapters[chapterIndex].listdata, segmentIndex, segment)
      this.scrollToTop()
    },
    scrollToTop () {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    },
    nextSegment () {
      let chapterIndex = this.currentChapterIndex
      let nextSegmentIndex = this.currentSegmentIndex + 1
      let chapter = this.chapters[chapterIndex]
      let nextSegment = chapter.listdata[nextSegmentIndex]
      if (chapter) {
        if (nextSegment) {
          this.changeCurrent(nextSegment, nextSegmentIndex, chapter, chapterIndex)
        } else {
          if (chapter.onstatus === 0) {
            chapterIndex = chapterIndex + 1
            chapter = this.chapters[chapterIndex]
            nextSegmentIndex = 0
            nextSegment = chapter.listdata[nextSegmentIndex]
            this.changeCurrent(nextSegment, nextSegmentIndex, chapter, chapterIndex)
          } else {
            this.switchToTopic(chapter, chapterIndex)
          }
        }
      } else {
        throw new Error('已经是最后一节课了')
      }
    },
    finishExstatus () {
      this.chapters[this.currentChapterIndex].exstatus = 1
    },
  },
  async mounted () {
    // 获取课程列表
    try {
      let response;
      // ${this.$route.params.id}
      response = await api.getPreshowData(this.$route.params.id)
      for (let chapter of response.data.coulist) {
        for (let segment of chapter.listdata) {
          segment.isCurrent = false
        }
      }
      this.chapters = response.data.coulist
      this.info = response.data.mallinfo
      this.lessonInfo = response.data.mallinfo
      this.downloads = response.data.downs
    } catch (e) {
      throw new Error(`出错了，凶手是${e}`);
    }
    // 获取章节信息
    let currentChapterIndex = parseInt(this.$route.params.chapterid)
    let currentSegmentIndex = parseInt(this.$route.params.segmentid)
    // 如果只有章没有节 就去做题
    if (Number.isInteger(currentChapterIndex) && !Number.isInteger(currentSegmentIndex)){
      // 如果发现没有题 就去本章第一节
      if (this.chapters[currentChapterIndex].onstatus) {
        this.switchToTopic(this.chapters[currentChapterIndex], currentChapterIndex)
        return
      } else {
        currentSegmentIndex = 0
      }
    }

    if (!currentChapterIndex && !currentSegmentIndex) {
      currentChapterIndex = 0
      currentSegmentIndex = 0
    }

    // 获取当前课程
    if (Number.isInteger(currentChapterIndex) && Number.isInteger(currentSegmentIndex)) {
      this.currentChapterIndex = currentChapterIndex
      this.currentSegmentIndex = currentSegmentIndex
      let currentSegment = this.chapters[this.currentChapterIndex].listdata[this.currentSegmentIndex]
      currentSegment.isCurrent = true
      this.current = currentSegment
    }
  },
  watch: {
    async current (val) {
      if (val.chapterorder && val.listorder) {
        await api.updateRecentlyStudied(this.$route.params.id, val.chapterorder, val.listorder)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.e-study{
  width: 100%;
  height: 100%;
  .e-study-video{
    width: 100%;
    padding-left: 65px;
    background-color: #ccc;
    box-sizing: border-box;
    position: absolute;
    top: 0px;
    padding-top: 55px;
    height: 100%;
    justify-content: center;
    align-items: center;
    display: flex;
  }
  .e-study-tabs{
    height: 45px;
    width: 100%;
    display: flex;
    justify-content: center;
    background-color: #fff;
    li{
      margin-right: 40px;
      padding-top: 11px;
      line-height: 34px;
      color: #596067;
      position: relative;
      &:nth-last-child(1) {
        margin: 0;
      }
      &.act{
        color: #F54747;
        &::after{
          position: absolute;
          content: '';
          width: 15px;
          height: 3px;
          border-radius: 3px;
          left: 50%;
          bottom: 0;
          transform: translateX(-50%);
          background-color: #F54747;
        }
      }
    }
  }
  .e-study-topic{
    box-sizing: border-box;
    padding-top: 135px;
    padding-left: 65px;
    height: 100%;
    overflow: scroll;
  }
  .e-study-left-nav-item-content{
    padding-top: 20px;
    background-color: #fff;
    transition: all .3s;
    overflow-y: auto;
    padding-bottom: 40px;
    box-sizing: border-box;
    .e-study-left-nav-item-chapters{
      padding: 0 14px;
      .e-study-left-nav-item-chapter{
        margin-bottom: 30px;
        .e-study-left-nav-item-chapter-title{
          line-height: 19px;
          font-size: 14px;
          color: #212121;
          font-weight: 700;
          text-align: left;
          margin-bottom: 9px;
        }
        .e-study-left-nav-item-segments{
          .e-study-left-nav-item-segment{
            text-align: left;
            font-size: 12px;
            line-height: 28px;
            height: 28px;
            overflow: hidden;
            padding-right: 20px;
            color: #5D6064;
            padding-left: 14px;
            margin-bottom: 5px;
            position: relative;
            vertical-align: top;
            a{
              display: block;
              text-decoration: none;
              color: #5D6064;
            }
            &:nth-last-child(1){
              margin-bottom: 0;
            }
            &:hover{
              background-color: #F9F9F9;
            }
            .icon-zhuxingtu{
              &::before{
                display: inline-block;
                -webkit-transform: rotate(90deg);
                transform: rotate(90deg);
              }
            }
            .e-study-left-nav-item-segment-play{
              position: absolute;
              left: 0px;
              top: 1px;
              line-height: 28px;
              font-size: 12px;
              transform: scale(.7)
            }
            .e-study-left-nav-item-segment-state{
              width: 6px;
              height: 6px;
              border: 2px solid #CACDD2;
              position: absolute;
              right: 10px;
              top: 50%;
              transform: translateY(-50%);
              border-radius: 50%;
            }
            .e-study-left-nav-item-segment-state-done{
              background-color: #29C23D;
              border-color: #29C23D;
            }
            .e-study-left-nav-item-segment-state-doing{
              border-color: #29C23D;
              background-color: transparent;
            }
          }
        }
      }
    }
    .e-study-left-nav-item-content-download{
      padding: 0 20px;
      li{
        padding-right: 50px;
        padding-left: 42px;
        position: relative;
        line-height: 25px;
        font-size: 13px;
        height: 25px;
        overflow: hidden;
        margin-bottom: 14px;
        text-align: left;
        color: #5D6064;
        line-height: 25px;
        &:hover{
          color: #29C23D;
          a{
            background-color: #29C23D;
            color: white;
          }
        }
        span{
          position: absolute;
          display: block;
          left: 0;
          top: 1.5px;
          font-size: 12px;
          height: 22px;
          line-height: 22px;
          border-radius: 11px;
          width: 36px;
          color: white;
          background-color: #DBDBDB;
          text-align: center;
        }
        a{
          position: absolute;
          top: 0;
          right: 0;
          color: white;
          display: block;
          text-align: center;
          line-height: 25px;
          height: 25px;
          text-decoration: none;
          width: 46px;
          border-radius: 13px;
          color: #29C23D;
          transition: all .3s;
        }
      }
    }
  }
  .e-study-download{
    padding: 0 14px;
    margin-top: 25px;
    .e-program-file-item{
      padding-right: 50px;
      padding-left: 42px;
      position: relative;
      line-height: 22px;
      font-size: 13px;
      height: 22px;
      overflow: hidden;
      margin-bottom: 12px;
      list-style: none;
      span{
        position: absolute;
        display: block;
        left: 0;
        top: 0;
        font-size: 12px;
        height: 22px;
        line-height: 22px;
        border-radius: 11px;
        width: 36px;
        color: #AAACAF;
        background-color: #F8F8F8;
        text-align: center;
      }
      a{
        position: absolute;
        bottom: 0;
        right: 0;
        color: white;
        background-color: #29C23D;
        display: block;
        text-align: center;
        line-height: 22px;
        height: 22px;
        text-decoration: none;
        font-size: 12px;
        width: 46px;
        border-radius: 13px;
      }
    }
  }
}
</style>
